import { Component, OnInit,EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutesEnum, VendorListEnum } from '@app/shared/constants/global.enum';
import { VendorEmployeeCount } from '@app/shared/interfaces/vendor-management-model';

@Component({
  selector: 'app-vendor-profile',
  templateUrl: './vendor-profile.component.html',
  styleUrls: ['./vendor-profile.component.scss'],
})
export class VendorProfileComponent implements OnInit {
  @Input() vendorId: string = '';
  vendorName: string | null = null;
  vendorList = VendorListEnum;
  RoutesEnum =RoutesEnum;
  @Input() vendorEmployeeData: VendorEmployeeCount | null = null;
  @Output() close = new EventEmitter<void>();

  constructor(private route: ActivatedRoute,private router: Router) {}

  ngOnInit(): void {
    // this.route.params.subscribe(params => {
    //   this.vendorId = params['vendorId'];
    //   this.vendorName = params['vendorName'] ? decodeURIComponent(params['vendorName']) : null;
    // });
    this.vendorId = this.vendorEmployeeData?.vendorId != null ? String(this.vendorEmployeeData.vendorId) : '';
    this.vendorName = this.vendorEmployeeData?.vendorName || null;
  }
   navigateToVendorDashboard(): void {
    this.router.navigate([`/${RoutesEnum.VendorManagement}`]);
  }
  navigateBack() {
    console.log('Navigating back to Vendors List');
    this.close.emit();
  }
}